// Keys to preserve across cleanup (user preferences only)
const KEYS_TO_PRESERVE = ["theme", "language", "i18nextLng"];

// Clear Auth0-specific keys explicitly
const clearAuth0SpecificStorage = () => {
    const allKeys = Object.keys(localStorage);
    
    allKeys.forEach((key) => {
        // Target Auth0 SDK cache keys
        if (
            key.includes("@@auth0spajs@@") ||
            key.startsWith("auth0LastLoginAt:") ||
            key === "auth0Username" ||
            key === "LOGIN_AUDIT_DONE"
        ) {
            console.log("🧹 Removing Auth0 key:", key);
            localStorage.removeItem(key);
        }
    });
};

const clearStorages = () => {
    const preservedData = {};
    KEYS_TO_PRESERVE.forEach((key) => {
        const value = localStorage.getItem(key);
        if (value) {
            preservedData[key] = value;
        }
    });

    localStorage.clear();
    sessionStorage.clear();

    Object.entries(preservedData).forEach(([key, value]) => {
        localStorage.setItem(key, value);
    });
};

const clearAllCookies = () => {
    const cookies = document.cookie.split(";");
    // eslint-disable-next-line no-restricted-globals
    const hostname = window.location.hostname;
    const expiredDate = "Thu, 01 Jan 1970 00:00:00 GMT";

    cookies.forEach((cookie) => {
        const eqPos = cookie.indexOf("=");
        const name = eqPos > -1 ? cookie.substring(0, eqPos).trim() : cookie.trim();
        document.cookie = `${name}=;expires=${expiredDate};path=/`;
        document.cookie = `${name}=;expires=${expiredDate};path=/;domain=${hostname}`;
        document.cookie = `${name}=;expires=${expiredDate};path=/;domain=.${hostname}`;
    });
};

const clearBrowserCaches = () => {
    // eslint-disable-next-line no-restricted-globals
    if ("caches" in window) {
        caches.keys().then((cacheNames) => {
            cacheNames.forEach((cacheName) => caches.delete(cacheName));
        }).catch(() => { });
    }
};

const clearIndexedDB = () => {
    // eslint-disable-next-line no-restricted-globals
    if (window.indexedDB && indexedDB.databases) {
        indexedDB.databases().then((dbs) => {
            dbs.forEach((db) => {
                if (db.name) {
                    indexedDB.deleteDatabase(db.name);
                }
            });
        }).catch(() => { });
    }
};

// NUCLEAR OPTION: Full cleanup on every app load
// Clears all Auth0 state while preserving user preferences (theme/language)
export const performFullCacheCleanup = () => {
    try {
        console.log("🧹 Performing FULL cache cleanup on app load...");
        
        // Clear Auth0-specific keys first (most critical)
        clearAuth0SpecificStorage();
        
        // Clear all storage (preserving only theme/language preferences)
        clearStorages();
        
        // Clear all cookies
        clearAllCookies();
        
        // Clear browser caches
        clearBrowserCaches();
        
        // Clear IndexedDB
        clearIndexedDB();
        
        console.log("✓ Full cache cleanup complete - fresh session guaranteed");
        return true;
    } catch (err) {
        console.error("❌ Cache cleanup failed:", err);
        return false;
    }
};

// Legacy exports for backward compatibility
export const performVersionAwareCacheCleanup = () => performFullCacheCleanup();
export const performOneTimeCacheCleanup = () => performFullCacheCleanup();
